function widont(value) {
    if (!value) {
        return value;
    }

    return value.replace(/([^\s])\s+([^\s]+)\s*$/gm, '$1 $2');
}

export default widont;
